<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Métodos de Pago
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#ff9900;color:white;") Nuevo Método
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Método de pago
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md6, sm6)
                          v-form(enctype="multipart/form-data")

                            v-select(outline
                            :items="modulos"
                            v-model="form.modulo"
                            prepend-inner-icon="description"
                            label="Módulo:")

                            v-select(outline
                            v-if='form.modulo'
                            :items="tipos"
                            v-model="form.tipo"
                            @change="onTipoChange"
                            prepend-inner-icon="description"
                            label="Tipo:")

                            v-select(outline
                            v-if='form.tipo'
                            :items="monedas"
                            v-model="form.moneda"
                            prepend-inner-icon="description"
                            label="Moneda:")

                            v-text-field(outline
                            v-if='form.tipo'
                            v-model="form.nombre"
                            prepend-inner-icon="description"
                            label="Nombre:")

                            v-text-field(outline
                            v-if='form.tipo == "Banco"'
                            v-model="form.cod_cta"
                            prepend-inner-icon="description"
                            label="Código cuenta:")

                            v-text-field(outline
                            v-if='form.tipo == "Banco"'
                            v-model="form.co_ban"
                            prepend-inner-icon="description"
                            label="Código banco:")

                            v-text-field(outline
                            v-if='form.tipo == "Caja" || form.tipo == "Efectivo"'
                            v-model="form.caja"
                            prepend-inner-icon="description"
                            label="Código caja:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:#ff9900;color:white;border-radius:10px;", @click.native='save') Guardar
                                    v-btn(style="background:black;color:white;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Métodos de Pago
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td(v-if='props.item.modulo') {{ props.item.modulo}}
            td(v-else) N/A
            td(v-if='props.item.nombre') {{ props.item.nombre}}
            td(v-else) N/A
            td(v-if='props.item.moneda') {{ props.item.moneda}}
            td(v-else) N/A
            td(v-if='props.item.tipo') {{ props.item.tipo}}
            td(v-else) N/A
            td(v-if='props.item.co_ban') {{ props.item.co_ban}}
            td(v-else) N/A
            td(v-if='props.item.cod_cta') {{ props.item.cod_cta}}
            td(v-else-if='props.item.caja') {{ props.item.caja}}
            td(v-else) N/A
            td(v-if='props.item.createdAt') {{ props.item.createdAt | moment("DD/MM/YYYY")}}
            td(v-else) N/A
            td
                v-btn.mx-0(v-if='mod' icon, @click='editItem(props.item)')
                    v-icon(color='teal') edit
                v-btn.mx-0(v-if='elm' icon, @click='deleteItem(props.item)')
                    v-icon(color='pink') delete
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "MetodoPago",
  data: () => ({
    ruta: server + ":" + port,
    loading: false,
    form: {
      nombre: "",
      cod_cta: "",
      co_ban: "",
      co_tar: "",
      cta_ingr_egr: "",
      caja: "",
      moneda: "",
      tipo: "",
      modulo: ""
    },
    monedas: ["BS", "USD"],
    modulos: ["CobroApp", "DepositoApp", "ValijasAdmin"],
    tipos: ["Banco", "Caja", "Efectivo"],
    cuentas: [],
    dialog: false,
    editedIndex: -1,
    resultados: [],
    headers: [
      { text: "Módulo", value: "modulo" },
      { text: "Nombre", value: "nombre" },
      { text: "Moneda", value: "moneda" },
      { text: "Tipo", value: "tipo" },
      { text: "Código Banco", value: "co_ban" },
      { text: "Código Cuenta / Caja", value: "cod_cta" },
      { text: "Fecha", value: "createdAt" },
      { text: "Acción" }
    ],
    defaultForm: {
      nombre: "",
      cod_cta: "",
      co_ban: "",
      co_tar: "",
      cta_ingr_egr: "",
      moneda: "",
      caja: "",
      tipo: "",
      modulo: ""
    },
    cre: "yes",
    mod: "yes",
    elm: "yes"
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      if (
        this.$store.state.adminelgocho &&
        this.$store.state.adminelgocho.permisos
      ) {
        let encontrado = false;
        for (
          let i = 0;
          i < this.$store.state.adminelgocho.permisos.length;
          i++
        ) {
          if (
            this.$store.state.adminelgocho.permisos[i].ruta === "Metodo de Pago"
          ) {
            encontrado = true;
            this.cre = "";
            this.mod = "";
            this.elm = "";
            for (
              let j = 0;
              j < this.$store.state.adminelgocho.permisos[i].accion.length;
              j++
            ) {
              if (
                this.$store.state.adminelgocho.permisos[i].accion[j] === "Crear"
              ) {
                this.cre = "yes";
              }
              if (
                this.$store.state.adminelgocho.permisos[i].accion[j] ===
                "Modificar"
              ) {
                this.mod = "yes";
              }
              if (
                this.$store.state.adminelgocho.permisos[i].accion[j] ===
                "Eliminar"
              ) {
                this.elm = "yes";
              }
            }
          }
        }
        if (!encontrado) {
          this.cre = "yes";
          this.mod = "yes";
          this.elm = "yes";
        }
      }
    },
    initialize() {
      this.editedIndex = -1;
      Api.get("metodopago").then(res => {
        this.resultados = res.data;
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.initialize();
    },
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, Eliminar!"
        })
        .then(result => {
          if (result.value) {
            Api.delete("metodopago/" + item._id)
              .then(() => {
                this.$swal.fire(
                  "Felicidades.!",
                  "Eliminación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              })
              .catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
              });
          }
        });
    },
    onTipoChange() {
      if (this.form.tipo === "Banco") {
        this.form.caja = "";
      } else if (this.form.tipo === "Caja" || this.form.tipo === "Efectivo") {
        this.form.cod_cta = "";
        this.form.co_ban = "";
      }
    },
    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      this.form = Object.assign({}, this.defaultForm);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    validacion() {
      if (
        this.form.modulo &&
        this.form.tipo &&
        this.form.nombre &&
        this.form.moneda
      ) {
        if (this.form.tipo == "Banco" && (this.form.cod_cta || this.form.co_ban)) return true;
        if (this.form.tipo == "Caja" && this.form.caja) return true;
        if (this.form.tipo == "Efectivo" && this.form.caja) return true;
        return false;
      } else return false;
    },
    save() {
      this.loading = true;
      if (this.validacion()) {
        if (this.editedIndex > -1) {
          Api.put("metodopago", this.form)
            .then(() => {
              this.form = Object.assign({}, this.defaultForm);
              this.dialog = false;
              this.$swal.fire(
                "Felicidades.!",
                "Modificación realizada exitosamente.",
                "success"
              );
              this.loading = false;
              this.initialize();
            })
            .catch(err => {
              // eslint-disable-next-line no-console
              console.log(err);
              this.loading = false;
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        } else {
          Api.post("metodopago", this.form)
            .then(() => {
              this.form = Object.assign({}, this.defaultForm);
              this.dialog = false;
              this.$swal.fire(
                "Felicidades.!",
                "Registro realizado exitosamente.",
                "success"
              );
              this.loading = false;
              this.initialize();
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        }
      } else {
        this.loading = false;
        this.$swal.fire(
          "Oops...",
          "Error encontrado, debe ingresar todos los campos correspondientes.",
          "error"
        );
      }
    }
  }
};
</script>
<style lang="scss">
@media only screen and (max-width: 600px) {
  .wdd {
    width: 200px !important;
  }
}
.cll {
  .v-messages.theme--light {
    display: none !important;
  }
}
</style>
